module.exports = __webpack_public_path__ + "img/126.11c479c5.jpg";